import { render } from "./Trail.vue?vue&type=template&id=0b24c8b5&scoped=true"
import script from "./Trail.vue?vue&type=script&lang=js"
export * from "./Trail.vue?vue&type=script&lang=js"

import "./Trail.vue?vue&type=style&index=0&id=0b24c8b5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b24c8b5"

export default script